import React from "react";
import Snap from "snapsvg-cjs"

import svg from "./images/svg/home-splash.svg";
import "./Svg.css";

// mina is not exported from snapsvg-cjs
const mina = window.mina;


class Svg extends React.Component {

	componentDidMount() {
		// Allows to assign this to an attr in parent
		this.props.onRef(this);
		// Load SVG into the component
		this.svg = Snap(document.querySelector("#svg"));
		Snap.load(
			svg,
			function (data) {
				this.svg.append(data);
				// Set ready state
				this.props.onReady();
			}.bind(this),
		);
	}

	componentWillUnmount() {
		this.props.onRef(undefined);
	}

	transition(view) {
		// Show/hide elements of home-splash.svg
		document.querySelector("g[show]") ? document.querySelector("g[show]").removeAttribute("show") : null;
		view.g ? document.querySelector(view.g).setAttribute("show", "") : null;
		// Change background grdient color defined in App.js
		document.querySelector("#background").style.background = view.background;
		// We use the viewbox to perform transformation (scale/pan)
		// This always keeps the aspect ratio inside the frame
		// Only downside is it's a string, so need to split/join each time
		// Below is viewBox final/initial/difference
		var viewBox_f = view.viewBox.split(" ").map(Number);
		var viewBox_i = this.svg.attr("viewBox").vb.split(" ").map(Number);
		var viewBox_d = viewBox_f.map(function (val, index) { return val - viewBox_i[index]; });
		Snap.animate(
			0., 1.,
			function (step) {
				var viewBox_step = viewBox_i.map(function (val, index) { return val + step * viewBox_d[index]; });
				viewBox_step = viewBox_step.map(String).join(" ");
				this.svg.attr({ "viewBox": viewBox_step });
			}.bind(this),
			800,
			mina.easeinout,
			this.props.onTransitionEnd.bind(this)
		);
	}

	render() {
		return (
			<div>
			<div id="background"></div>
			<div id="backgroundGradient"></div>
			<svg id="svg"
				// viewBox="380 230 440 300"
				viewBox="496 266 400 450"
				xmlns="http://www.w3.org/2000/svg"
				preserveAspectRatio="xMidYMid meet">
			</svg>
			</div>
		);
	}

}

export default Svg;



// WEBPACK FOOTER //
// ./src/Svg.js